export default "__VITE_ASSET__a219c62f__"